import { NgModule } from '@angular/core';
import { ShowForJurisdictionDirective } from './directives/show-for-jurisdiction.directive';



@NgModule({
  declarations: [
    ShowForJurisdictionDirective
  ],
  imports: [
  ],
  exports: [
    ShowForJurisdictionDirective
  ]
})
export class ConfigModule { }
